export enum CertificateAccessStatus {
  accepted = 'accepted',
  canceled = 'canceled',
  waiting = 'waiting',
  empty = 'empty',
}
